<template>
  <div class="delivery-fullWrap">
    <div class="delivery-header" @click="goToBack()">
      <a><i class="fa-solid fa-angle-left"></i></a>
      <span v-html="$t('DELIVERY.LOCATION.add_adress_header_title')" />
    </div>
    <div class="delivery-body">
      <h2 v-html="$t('DELIVERY.LOCATION.add_adress_title')" />
      <p v-html="$t('DELIVERY.LOCATION.add_adress_subtitle')" />
      <img class="delivery-imgAddAddress" src="@/assets/address-illustration.png" alt="Añadir dirección"/>
      <div class="delivery-rowAddress" :class="{'delivery-inputTxt__error': alertInputAddAddress}">
        <transition enter-active-class="bounceIn" leave-active-class="bounceOut">
          <div v-if="alertInputAddAddress" class="delivery-errorAlert" data-testid="AddAddress-ErrorAlert">
          <i class="fa-sharp fa-regular fa-circle-exclamation"></i>
          <span v-html="$t('DELIVERY.LOCATION.alert_input_float')" />
          <div class="down-arrow" />
        </div>
        </transition>
        <i class="fa-regular fa-magnifying-glass"></i>
        <input  v-model="addressobj.address" type="text" :placeholder="$t('DELIVERY.LOCATION.add_adress_placeholder')" @input="changeaddress()" data-testid="AddAddress-AddressInput">
        <i class="fa-sharp fa-regular fa-arrow-right delivery-ctaSearch" @click="goToSearchAdress()" :class="{ 'show': alertBeforeInput }"></i>
      </div>
      <button class="delivery-btnAddress" :class="{ 'aviable': alertBeforeInput }" v-html="$t('DELIVERY.LOCATION.add_adress_search')" @click="goToSearchAdress()" data-testid="AddAddress-DeliveryBtn" />
      <button :class="flatActiveGps ? 'delivery-btnGps' : 'delivery-btnGps disable'" @click="openModalGps()" data-testid="AddAddress-DeliveryBtnGps">
        <i class="fa-light fa-location-arrow"></i>
        {{ $t('DELIVERY.LOCATION.add_adress_gps') }}
      </button>
      <div v-if="location !== null && !location.supplier_id">
        <span class="delivery-omitir" v-html="$t('DELIVERY.LOCATION.add_adress_skip')" @click="goToHomeDelivery()" />
        <div class="delivery-warning">
          <i class="fa-sharp fa-regular fa-circle-exclamation"></i>
          <p v-html="$t('DELIVERY.LOCATION.add_adress_skip_note')" />
        </div>
      </div>
      <div v-if="location !== null && location.supplier_id" class="delivery-currentAddress" @click="goToBack()">
        <i class="fa-sharp fa-regular fa-moped"></i>
        <div>
          <b v-html="$t('DELIVERY.LOCATION.add_adress_address_save')" />
          <p v-html="location.address" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { track } from "@/services/track-custom";

  export default {
    name : "AddAdress",
    props: {
      addressobj: Object,
      location: Object,
      flatActiveGps: Boolean,
    },
    data: () => ({
      alertInputAddAddress: false,
      validationError: String,
      isValid: Boolean,
      alertBeforeInput: false
    }),
    methods: {
      goToBack () {
        this.$emit('goToBack');
      },
      goToSearchAdress () {
        if (this.addressobj.address && this.addressobj.address.length >= 5 && this.isValid) {
          track.trackEventCluvi({search_term: this.addressobj.address}, "set location.search address");
          this.$emit('goToSearchAdress');
        } else {
          this.validationError = !this.isValid ? this.$t('DELIVERY.LOCATION.spaces_inputs') : this.$t('DELIVERY.LOCATION.alert_inputs');
          this.alertInputAddAddress = true;
        };
      },
      openModalGps () {
        track.trackEventCluvi({}, "set location.open gps");
        if (this.flatActiveGps) this.$emit('openModalGps');
      },
      goToHomeDelivery () {
        track.trackEventCluvi({}, "set location.omit set address");
        this.$emit('goToHomeDelivery');
      },
      changeaddress () {
        const regex = /^[^\s]+/;
        this.isValid = regex.test(this.addressobj.address);
        if (!this.isValid) {
          this.validationError = this.$t('DELIVERY.LOCATION.spaces_inputs');
          this.alertInputAddAddress = true;
        } else {
          this.validationError = "";
          this.alertInputAddAddress = false;
        };
        if (this.addressobj.address.length < 5) {
          this.alertBeforeInput = false;
        };
        if (this.addressobj.address.length >= 5) {
          this.alertBeforeInput = true;
        };
      }
    }
  }
</script>

